<template>
  <div class="patient">
    <div class="top">
      <h3>我的就诊人</h3>
      <span class="add" @click="edit('add')">新增</span>
    </div>
    <div class="content">
      <ul>
        <li class="item" v-for="(item, index) in patientList" :key="item.id">
          <div class="info">
            <p>姓名：{{item.name}}</p>
            <p>性别：{{item.sex == '1' ? '男' : '女'}}</p>
          </div>
          <div class="info">
            <p>身份证号码：{{item.idCard}}</p>
            <p>手机号码：{{item.mobile}}</p>
          </div>
          <div class="info" v-for="(infoItem, index) in item.patientSubDtos" :key="infoItem.id">
            <p>医院条码、病案号、一卡通号：{{ infoItem.hospitalName}}&nbsp&nbsp&nbsp{{infoItem.barcode}}</p>
          </div>
          <div class="info">
            <p>账号信息：{{item.jiuyiNo}}</p>
          </div>
          <div class="handle">
            <span class="edit" @click="edit('edit', item.id)">编辑</span>
            <span class="del" @click="del(item.id)">删除</span>
          </div>
        </li>
      </ul>
      <div class="pagin">
        <pagination :pageCount="pageCount" @pageSize="pageSize" />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pagination'
import {reqPatient, reqPatientDel} from '../../../api'
import {mapState} from 'vuex'
export default {
  data() {
    return {
      patientList: [], // 就诊人列表
      pageCount: 0
    }
  },
  created() {
    this._reqPatient()
  },
  methods: {
    // 获取就诊人列表
    _reqPatient(val) {
      reqPatient({pageIndex:val,pageSize:10}).then(res => {
        if(res.code === 200) {
          this.pageCount = res.data.pageCount
          this.patientList = res.data.bussData
        }
      })
    },
    // 分页
    pageSize(val) {
      this._reqPatient(val)
    },
    // 点击编辑和添加
    edit (type, id) {
      if (type === 'add') {
        this.$router.push(`/person/patient/edit?type=${type}`)
      } else if (type === 'edit') {
        this.$router.push(`/person/patient/edit?type=${type}&id=${id}`)
      }
    },
    // 删除
    del(id) {
      reqPatientDel(id).then(res => {
        if(res.code === 200){
          this.$message({
            message: '删除成功',
            type: 'error'
          })
          this._reqPatient()
        }
      })
    }
  },
  computed: {
    ...mapState(['patientInfo'])
  },
  components: {
    Pagination
  }
}
</script>

<style scoped lang="less" type="text/less">
.patient{
  .top{
    display: flex;
    justify-content: space-between;
    margin-top:60px;
    h3{
      font-size: 24px;
    }
    .add{
      display: block;
      width: 80px;
      height: 40px;
      border-radius: 20px;
      background: #2FA1DE;
      color:#fff;
      font-size: 16px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
  }
  .content{
    margin-top:30px;
    .item{
      position: relative;
      width:900px;
      padding:20px;
      box-sizing: border-box;
      box-shadow:0px 3px 9px 0px rgba(0, 0, 0, 0.09);
      border-radius:10px;
      .info{
        display: flex;
        margin-bottom: 30px;
        p{
          flex: 1;
        }
      }
      .handle{
        position: absolute;
        bottom: 20px;
        right: 20px;
        span{
          display: inline-block;
          width: 80px;
          height: 40px;
          margin-left: 20px;
          border:1px solid #999;
          border-radius: 20px;
          text-align: center;
          line-height: 40px;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
    .pagin{
      margin-top:40px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/Patient.vue